import React, { useState, useEffect } from "react";
import { Upload, message } from "antd";
import { CameraFilled, CameraOutlined, PlusOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import { fetchToken, triggerAfterUpload } from "../../../../API/API";
import axios from "axios";
import { AiOutlineCamera } from "react-icons/ai";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import cameraIcon from "../../../../assets/icons/camera_icon1.svg";
import TopAlert from "../../../../components/TopNotification/TopAlert";

const CompanyAvatar = (props) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const [RequestKey, setRequestKey] = useState();
  const [FileSize, setFileSize] = useState();
  const [imageUrl, setimageUrl] = useState("");
  const [uploadKey, setUploadKey] = useState(null);
  const [uploadURL, setUploadURL] = useState(null);
  const imageURL = JSON.parse(localStorage.getItem("profilePicture"));
  const [fileAttachment, setFileAttachment] = useState("");
  const [uploadedImage, setUploadedImage] = useState("");
  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);
  const [CorruptedFileCheck, setCorruptedFileCheck] = useState();
  // let uploadedImage;
  // let fileAttachment =[];
  // const [fileList1, setFileList1] = useState([
  //   props.state?
  //  {
  //   url: props.state.ProfileImageURL
  //  }:
  //  ""
  // ]);
  const [fileList1, setFileList1] = useState([]);

  const [fileList3, setFileList3] = useState([
    {
      url: imageURL
        ? `${process.env.REACT_APP_S3_URL}${
            imageURL?.charAt(0) !== "/" ? "/" : ""
          }${imageURL}`
        : null,
      uid: `${(Math.random() + 1).toString(36).substring(7)}`,
    },
  ]);

  const [fileList2, setFileList2] = useState([
    {
      url: props.state?.ProfileImageURL,

      // url: `${process.env.REACT_APP_S3_URL}${props.state?.ProfileImageURL?.charAt(0) !== "/" ? '/' : ""}${props.state?.ProfileImageURL}`
      // url: `${process.env.REACT_APP_S3_URL}${imageURL?.charAt(0) !== "/" ? '/' : ""}${imageURL}`,
      // uid:`${(Math.random() + 1).toString(36).substring(7)}`
    },
  ]);


  // console.log('FileList::1:>',fileList1);
  // console.log('FileList::2:>',fileList2);
  // console.log('FileList::3:>',fileList3);

  const beforeCropImage = (file) => {
    if (
      file.type != "image/png" &&
      file.type != "image/jpeg" &&
      file.type != "image/jpg"
    ) {
      setFileTypeCheck(true);
      setCorruptedFileCheck(true)
      props?.setImageLoading(false);
      return false;
    } else if (file.size > 10000000) {
      setFileSizeCheck(true);
      setCorruptedFileCheck(true)
      props?.setImageLoading(false);
      return false;
    } else {
      setCorruptedFileCheck(false);
      return true;
    }
  };

  const onChange = ({ fileList: newFileList }) => {
    if (CorruptedFileCheck) {
      setFileAttachment(null);
      setFileList1(null);
      setFileList2(null);
      setFileList3(null);
    } else {
      setFileAttachment(newFileList);
      setFileList1(newFileList);
      setFileList2(newFileList);
      setFileList3(newFileList);
      // fileAttachment=newFileList;
      if (newFileList?.length < 1) {
        props?.setDeleteCheck(true);
      } else {
        props?.setDeleteCheck(false);
      }
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };
  const handleBeforeUpload = (file) => {
    props?.setImageLoading(true);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        let image = document.createElement("img");
        image.src = event.target.result;

        image.onload = () => {
          if (
            file.type != "image/png" &&
            file.type != "image/jpeg" &&
            file.type != "image/jpg"
          ) {
            setFileTypeCheck(true);
            props?.setImageLoading(false);
          } else if (file.size > 10000000) {
            setFileSizeCheck(true);
            props?.setImageLoading(false);
          } else {
            resolve(file);
            setCorruptedFileCheck(false);
            onChange(file);
          }
        };

        image.onerror = () => {
          reject(new Error("Invalid image file"));
          // console.log('corrupt image')
          setFileList1(null);
          setFileTypeCheck(true);
          props?.setImageLoading(false);
          setCorruptedFileCheck(true);
        };
      };

      reader.readAsDataURL(file);
    });
  };

  const uploadImage = async (file) => {
    // const headers = fetchToken();
    setUploadedImage(file);
    // const payload = {
    //   type: "profilePic",
    //   contentType: file.type,
    // };
    // console.log('token is', headers);
    // const imageUrl = `https://kt6m7lx9vc.execute-api.us-east-2.amazonaws.com/staging/upload`
    // const data = await axios.post(imageUrl, payload, { headers });
    // console.log("pic url", data.data.uploadURL)

    // const uploadRequest = await axios.put(data.data.uploadURL, file)
    // ////////////
    const headers = await fetchToken();

    const payload = {
      type: "profilePic",
      contentType: file.type,
    };
    // const imageUrl = `${BackendApiBaseUrl}/upload`;
    // const data = await axios.post(imageUrl, payload, { headers });
    // var Key = data.data.Key;
    // await axios.put(data.data.uploadURL, file);

    const imageUrl = `${BackendApiBaseUrl}/upload`;
    props?.setImageLoading(true);
    try {
      const { data } = await axios.post(imageUrl, payload, { headers });
      var Key = data.Key;
      setUploadKey(data.Key);
      setUploadURL(data.uploadURL);
      // console.log('Avatar Image Key>>>',Key)
      // localStorage.setItem('profilePicture', JSON.stringify(Key));
      props?.setImageKey(Key);
      // try {
      //  const respones= await axios.put(data.uploadURL, file);
      //   // console.log("🚀 ~ file: CompanyAvatar.js:90 ~ uploadImage ~ respones", respones)
      // } catch (error) {

      // }
    } catch (error) {}
    getPicture(Key);
    setRequestKey(Key);
    setFileSize(file.size);
    props?.setImageLoading(false)
  };

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      // var key = imageURLSplit(url);
      getImage(url)
        .then((result) => {
          // console.log("profile picture: ", result);
          setimageUrl(result);
        })
        .catch(() => {});
    }
  };


  useEffect(() => {
    if (uploadKey !== null && uploadURL != null) {
      if (fileAttachment?.length > 0) {
        if (uploadedImage?.size > fileAttachment[0]?.size) {
          uploadCroppedImage();
        }
      }
    }
  }, [uploadKey, uploadURL, fileAttachment]);

  const uploadCroppedImage = async () => {
    try {
      const respones = await axios.put(
        uploadURL,
        fileAttachment[0]?.originFileObj
      );
      await triggerAfterUpload(uploadKey); // Trigger after upload actions
      props?.setImageLoading(false);
    } catch (error) {
      props?.setImageLoading(false);
    }
  };

  return (
    <div className="companyAvatar">
      {fileTypeCheck ? (
        <TopAlert
          display={"flex"}
          title={
            "Cannot open the this file. The file may be corrupt, or in an unsupported format."
          }
          type="warning"
        />
      ) : null}
      {fileSizeCheck ? (
        <TopAlert
          display={"flex"}
          title={"File size should not exceed 10MB"}
          type="warning"
        />
      ) : null}
      <ImgCrop rotate beforeCrop={beforeCropImage}>
        <Upload
          action={uploadImage}
          beforeUpload={handleBeforeUpload}
          onChange={onChange}
          listType="picture-card"
          // fileList={props.state ? fileList2 :fileList3.length !== 0?fileList3: fileList1}
          // fileList={props.state ? fileList2 :fileList3[0].url!== null?fileList3: fileList1}
          fileList={
            fileList2?.length > 0 && fileList2[0]?.url
              ? fileList2
              : fileList3?.length > 0 && fileList3[0]?.url !== null
              ? fileList3
              : fileList1
          }
          // fileList={fileList3}
          // className={props.state ? fileList2.length !== 0 ? "Test" : "companyAvatar" : fileList1.length !== 0 ? 'Test' : 'companyAvatar'}

          // className={fileList3[0].url!== null?'Test' : fileList2.length !== 0 ? "Test"  : fileList1.length !== 0 ? 'Test' : 'companyAvatar'}
          className={
            fileList3?.length > 0 && fileList3[0]?.url !== null
              ? "Test"
              : "companyAvatar"
          }
          // className={"Test"}
          maxCount={1}
          onPreview={onPreview}
          style={{ backgroundColor: "#eee" }}
        >
          {
            fileList1?.length == 0 && !props.companyProfile ? (
              <CameraOutlined style={{ color: "#7e7e7e" }} />
            ) : (
              <CameraFilled
                style={{ backgroundColor: "#eee", color: "black" }}
              />
            )
            // <cameraIcon className={'camera-filled'}/> : <CameraOutlined />
          }
        </Upload>
      </ImgCrop>
    </div>
  );
};

export default CompanyAvatar;
